module.exports = __webpack_public_path__ + "img/paypal.e97060aa.svg";